// copied from VPC, edited
import { FavoriteOutlineIcon } from '@tableau/icons/FavoriteOutlineIcon';
import { FavoriteSolidIcon } from '@tableau/icons/FavoriteSolidIcon';
import { Colors } from '@tableau/icons/util/Colors';

import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch, AnyAction } from 'redux';
import { classes, style } from 'typestyle';
import { Messages } from '../../../../gen-src/Localize';
import { AppState } from '../../../app/state/AppState';
import { addContentFavorite, removeContentFavorite } from '../../actions/FavoritesAction';
import { SearchResultItem } from '../../models/SearchResultTypes';
import { TelemetryService } from '../../services/TelemetryService';
import { PageHeaderStyles } from './PageHeaderStyles';

export interface FavoriteToggleDispatchProps {
  readonly addContentFavorite: (item: SearchResultItem) => void;
  readonly removeContentFavorite: (item: SearchResultItem) => void;
}

export const FavoriteToggleTestID = 'FavoriteToggle';

export type FavoriteToggleProps = FavoriteToggleStateProps & FavoriteToggleDispatchProps & FavoriteToggleOwnProps;

export class FavoriteToggle extends React.PureComponent<FavoriteToggleProps, FavoriteToggleState> {
  constructor(props: FavoriteToggleProps) {
    super(props);
    this.state = { isFavorite: this.props.searchResultItem.favorite || false };
  }

  public componentDidUpdate(prevProps: FavoriteToggleOwnProps) {
    if (prevProps.searchResultItem.favorite !== this.props.searchResultItem.favorite) {
      this.setState({ isFavorite: this.props.searchResultItem.favorite || false });
    }
  }

  public render() {
    return this.renderFavoriteToggle();
  }

  private renderFavoriteToggle = () => {
    const buttonClasses = classes(FavoriteButtonStyle, PageHeaderStyles.FavoriteButtonFocusClass);

    const icon = this.state.isFavorite ? FavoriteSolidIcon : FavoriteOutlineIcon;

    const { ...domAttrs } = this.props;

    return (
      <span
        data-tb-test-id={FavoriteToggleTestID}
        className={buttonClasses}
        tabIndex={0}
        onClick={(event: React.SyntheticEvent<HTMLSpanElement>) => {
          this.boundHandleClick(event);
        }}
        onKeyDown={this.boundHandleKeypress}
        title={this.state.isFavorite ? Messages.favoritesTitleNotFavorited() : Messages.favoritesTitleFavorited()}
        role={'button'}
        aria-pressed={this.state.isFavorite}
        {...domAttrs}
      >
        {icon({ size: 20, color: Colors.Default })}
      </span>
    );
  };

  private boundHandleClick = (event: React.SyntheticEvent<HTMLSpanElement>) => {
    this.state.isFavorite
      ? this.props.removeContentFavorite(this.props.searchResultItem)
      : this.props.addContentFavorite(this.props.searchResultItem);
    this.setState({ isFavorite: !this.state.isFavorite });
    TelemetryService.instance.sendSearchResultClickedEvent({
      type: 'SearchResultClicked',
      eventSource: 'favoriteToggle',
      resultType: (!this.state.isFavorite).toString(),
      seeAll: true,
      index: 0,
      total: 0,
      searchTerm: this.props.searchTerm,
      contentId: this.props.searchResultItem.id,
    });
    event.preventDefault();
    event.stopPropagation();
  };

  private boundHandleKeypress = (event: React.KeyboardEvent<HTMLSpanElement>) => {
    if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
      this.boundHandleClick(event);
    }
  };
}

interface FavoriteToggleOwnProps {
  searchResultItem: SearchResultItem;
  // hideHelpTooltip?: boolean;
}

interface FavoriteToggleStateProps {
  searchTerm: string;
}

interface FavoriteToggleState {
  isFavorite: boolean;
}

const mapStateToProps = (state: AppState) => ({
  searchTerm: state.search.searchTerm,
});

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) =>
  bindActionCreators(
    {
      addContentFavorite: addContentFavorite,
      removeContentFavorite: removeContentFavorite,
    },
    dispatch
  );

export const ConnectedFavoriteToggle: React.ComponentClass<FavoriteToggleOwnProps> = connect(
  mapStateToProps,
  mapDispatchToProps
)(FavoriteToggle);

export const FavoriteButtonStyle = style({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '24px',
  minWidth: '24px',
  height: '24px',
  border: '1px solid transparent',
  boxSizing: 'border-box',
  borderRadius: '2px',
  $nest: {
    '&:focus': {
      outline: '0px',
      border: '1px solid #3498DB',
      boxShadow: '0 0 4px #3498DB',
    },
    '&:hover': {
      outline: '0px',
      backgroundColor: '#EBEBEB',
    },
  },
});
